export default {
    setEvents(state, payload) {
        state.events = payload
    },
    setRegistrationList(state, payload) {
        state.registrationList = payload
    }
}